import { useState, useEffect, useRef } from 'react';
import { X, Calculator, Phone } from 'lucide-react';

const SARAH_IMG = '/images/sarah.jpg';

export default function ExitIntentPopup() {
  const [show, setShow] = useState(false);
  const firedRef = useRef(false);

  useEffect(() => {
    // Check if already shown this session
    if (sessionStorage.getItem('exit_popup_shown')) return;

    const isMobile = window.innerWidth < 768;
    let maxScroll = 0;

    if (!isMobile) {
      // Desktop: mouse leaves top of window
      const handleMouseLeave = (e) => {
        if (e.clientY <= 5 && !firedRef.current) {
          firedRef.current = true;
          sessionStorage.setItem('exit_popup_shown', '1');
          setShow(true);
        }
      };
      document.addEventListener('mouseleave', handleMouseLeave);
      return () => document.removeEventListener('mouseleave', handleMouseLeave);
    } else {
      // Mobile: scroll back up after scrolling down
      const handleScroll = () => {
        const scrollY = window.scrollY;
        if (scrollY > maxScroll) maxScroll = scrollY;
        if (maxScroll > 500 && (maxScroll - scrollY) > 300 && !firedRef.current) {
          firedRef.current = true;
          sessionStorage.setItem('exit_popup_shown', '1');
          setShow(true);
        }
      };
      window.addEventListener('scroll', handleScroll, { passive: true });
      return () => window.removeEventListener('scroll', handleScroll);
    }
  }, []);

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center p-4" data-testid="exit-popup">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={() => setShow(false)} />
      {/* Modal */}
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-sm p-8 text-center animate-fadeInUp">
        <button onClick={() => setShow(false)} className="absolute top-3 right-3 text-gray-400 hover:text-gray-600" aria-label="Close" data-testid="exit-popup-close"><X className="w-5 h-5" /></button>
        <img src={SARAH_IMG} alt="Sarah" className="w-20 h-20 rounded-full mx-auto mb-4 border-4 border-gray-100 shadow-md object-cover" />
        <h2 className="text-xl font-extrabold text-cwc-navy mb-2">Wait — want to know what you SHOULD be paying?</h2>
        <p className="text-gray-500 text-sm mb-6">Most CA businesses overpay for workers comp. See your number in <strong className="text-red-600">60 seconds, free</strong> — no calls, no email needed.</p>
        <div className="space-y-3">
          <a href="https://calculator.compareworkerscomp.com" className="flex items-center justify-center gap-2 w-full bg-cwc-navy text-white font-bold py-3.5 rounded-xl hover:bg-cwc-navy-light transition-colors text-sm" data-testid="exit-popup-calculator">
            <Calculator className="w-5 h-5" /> Check My Rate — Free Calculator
          </a>
          <a href="tel:+14159282886" className="flex items-center justify-center gap-2 w-full bg-red-600 text-white font-bold py-3.5 rounded-xl hover:bg-red-700 transition-colors text-sm" data-testid="exit-popup-call">
            <Phone className="w-5 h-5" /> Talk To An Agent Now
          </a>
        </div>
        <button onClick={() => setShow(false)} className="text-gray-400 text-xs mt-4 hover:text-gray-600 transition-colors" data-testid="exit-popup-dismiss">No thanks, I'm good</button>
      </div>
    </div>
  );
}
